import { FC, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useAppSelector } from '../../store/hooks'
import { EUserRole } from '../../constants/approval'
import OwnershipCertificate from './OwnershipCertificate/OwnershipCertificate'
import OwnershipCertificateSelfRedeemed from './OwnershipCertificateSelfRedeemed/OwnershipCertificateSelfRedeemed'
import { useTranslation } from 'react-i18next'
import style from './style.m.less'
import { BackArrow } from '../ui'
import { PageContainer, PageTitle } from '../ui/PageElements'
import { Tabs } from 'antd'
import useRequest from '../hooks/useRequest'
import { RequestTypes } from '../hooks'
import OwnershipCertificateExternal from './OwnershipCertificateExternal/OwnershipCertificateExternal'

const { TabPane } = Tabs

const OwnershipCertificates: FC = () => {
    const { t } = useTranslation()
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const initialTab = queryParams.get('tab') === '1' ? '1' : '0'

    const userInfo = useAppSelector((store) => store.user)
    const { data } = userInfo
    const isGOOwner = data?.user_role === EUserRole.GOOwner
    const [currentOption, setCurrentOption] = useState(initialTab)

    const { fetch: fetchPermission, result: resultPermission } = useRequest({
        link: '/api/extension/v1/extension/ownership_certificates/external/permission',
        method: RequestTypes.get,
    })

    useEffect(() => {
        if (data.uid) {
            const queryParams = new URLSearchParams({
                user_id: data.uid,
            })
            fetchPermission({
                addToLink: `?${queryParams.toString()}`,
            })
        }
    }, [data])

    const tabsList = [
        { label: t('ownershipCertificate.certTable.certificates'), key: 0 },
        {
            label: t('ownershipCertificate.certTable.certificatesSelfRedeemed'),
            key: 1,
        },
    ]
    const tabsListExternal = [
        { label: t('ownershipCertificate.certTable.certificates'), key: 0 },
        {
            label: t('ownershipCertificate.certTable.certificatesExternal'),
            key: 1,
        },
    ]

    return (
        <PageContainer className={style.container}>
            <PageTitle
                title={
                    <>
                        <BackArrow link="/user-my-green-tools" />
                        {t('ownershipCertificate.certTable.certificates')}
                    </>
                }
            />
            {!resultPermission ? (
                <>
                    {isGOOwner ? (
                        <>
                            <Tabs
                                defaultActiveKey={initialTab}
                                onChange={(activeKey) => {
                                    setCurrentOption(activeKey)
                                }}
                                activeKey={currentOption}
                                className={style.tabs}
                            >
                                {tabsList.map((item) => {
                                    const { label, key } = item

                                    return <TabPane tab={label} key={key} />
                                })}
                            </Tabs>
                            {currentOption === '0' && <OwnershipCertificate />}
                            {currentOption === '1' && <OwnershipCertificateSelfRedeemed />}
                        </>
                    ) : (
                        <OwnershipCertificate />
                    )}
                </>
            ) : (
                <>
                    <Tabs
                        defaultActiveKey={initialTab}
                        onChange={(activeKey) => {
                            setCurrentOption(activeKey)
                        }}
                        activeKey={currentOption}
                        className={style.tabs}
                    >
                        {tabsListExternal.map((item) => {
                            const { label, key } = item

                            return <TabPane tab={label} key={key} />
                        })}
                    </Tabs>
                    {currentOption === '0' && <OwnershipCertificate />}
                    {currentOption === '1' && <OwnershipCertificateExternal />}
                </>
            )}
        </PageContainer>
    )
}
export default OwnershipCertificates
